import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Language } from 'spa-ionata-admin/types';
import langService from 'spa-ionata-admin/lib/services/Languages';
import { isDev } from '../config';

const _settings = (() => {
  try {
    return JSON.parse(localStorage.getItem('settings') || '{}') || {};
  } catch (e) {
    return {};
  }
})();

@Module({
  name: 'SettingsModule',
  namespaced: true,
})
export default class SettingsModule extends VuexModule {
  lang: string =
    langService.langsForCodes([_settings.lang, navigator.language])[0]?.code ||
    langService.default.code;

  debugMode = false;

  get asMap(): HashAny {
    return {
      lang: this.lang,
    };
  }

  @Action
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setCurrentLang(lang: string | Language) {
    const code =
      typeof lang === 'string'
        ? langService.langForCode(lang)?.code
        : lang.code;
    if (!code) {
      return;
    }
    this._setLang(code);
    langService.selectedCode = code;
    localStorage.setItem('settings', JSON.stringify(this.asMap));
  }

  @Mutation
  setDebugMode(value: boolean) {
    if (isDev) {
      this.debugMode = !!value;
    }
  }

  @Mutation
  _setLang(lang: string) {
    this.lang = lang;
  }
}
